
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/demo/codeDemo/tokenizer.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-markdown/demo/codeDemo/tokenizer.md?type=demo')
};